import type { ReactNode } from 'react';

/** Neutral metadata chip: branch, cron, version, role. One size. */
export function Chip({
  mono = false,
  className = '',
  title,
  children,
}: {
  mono?: boolean;
  className?: string;
  title?: string;
  children: ReactNode;
}) {
  return (
    <span
      className={`inline-flex items-center rounded border border-line bg-surface-2 px-2 py-0.5 text-xs text-ink-muted ${mono ? 'font-mono' : ''} ${className}`}
      title={title}
    >
      {children}
    </span>
  );
}
